import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  rootNoData: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F7F8FC',
    color: '#9A9AAF',
    height: '224px',
    boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.03)',
    fontWeight: 400,
    fontSize: '14px',
    position: 'relative',
  },
  noDataText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '16px',
    color: '#9A9AAF',
    marginTop: '16px',
    marginBottom: '12px',
    whiteSpace: 'pre-wrap',
    textAlign: 'center',
  },
  integrationIdInput: {
    marginBottom: '16px',
  },
  importChoice: {
    width: 'calc((100% - 25px) / 2)',
    marginLeft: '24px',
    textAlign: 'center',
  },
  newEvaluationChoice: {
    width: 'calc((100% - 25px) / 2)',
    marginRight: '24px',
    textAlign: 'center',
  },
  evaluateBtnIcon: {
    marginRight: '6px',
  },
  progressBar: {},
  thirdpartyName: {
    fontWeight: 400,
    fontFamily: 'Inter',
    fontSize: '18px',
  },
  stepTitle: {
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '140%',
    marginBottom: '16px',
    display: 'flex',
    marginTop: '16px',
  },
  stepTitleTooltip: {
    display: 'flex',
  },
  stepChoices: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '16px',
    width: "100%"
  },
  btnWrapper: {
    display: 'flex',
    justifyContent: 'right',
    gap: '16px',
    width: '100%',
    paddingTop: '24px',
  },
  finalButtonWrapper: {
    paddingTop: '32px',
    display: 'flex',
    gap: '16px',
  },
  'separator-vertical': {
    margin: '0 48px',
  },
  'separator-horizontal': {
    margin: '16px 0',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: '#F7F8FC',
    color: '#9A9AAF',
    height: '100%',
    boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.03)',
    fontWeight: 400,
    fontSize: '14px',
    padding: '16px',
  },
  label: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '130%',
    color: theme.palette.grey.grey500,
    marginBottom: '16px',
  },
  choiceBlocLabel: {
    color: theme.palette.primary.main,
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '130%',
    paddingTop: '16px',
    display: 'flex',
    alignItems: 'flex-start',
    '& img': {
      marginTop: '2px',
      marginRight: '10px',
    },
  },
  choiceBlocSubLabel: {
    color: theme.palette.grey.grey500,
    fontFamily: 'Inter',
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '140%',
  },
  inputBloc: {
    paddingBottom: '16px',
    paddingRight: '16px',
    '& .MuiAutocomplete-root': {
      marginTop: '8px',
      '& .MuiInputBase-root': {
        backgroundColor: '#FFF',
      },
    },
    '& .react-tel-input': {
      marginTop: '8px',
    },
    '& .phone-error': {
      backgroundColor: theme.palette.error.main,
    },
  },
  input: {
    width: '100%',
    marginTop: '8px',
    '& .MuiOutlinedInput-root': {
      fontSize: '14px',
      fontWeight: 400,
      height: '40px',
      backgroundColor: '#FFF',
    },
  },
  inputError: {
    '& .MuiOutlinedInput-root': {
      fontSize: '14px',
      fontWeight: 400,
      borderRadius: '12px',
      height: '40px',
      border: '1px solid #FFCCCC',
      color: theme.palette.error.error600,

      '& .MuiOutlinedInput-notchedOutline': {
        border: '0px solid #FFCCCC !important',
      },
    },

    '& .Mui-error': {
      color: theme.palette.error.error600,
    },
  },
  progressWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '65px',
    minHeight: '235px',
    backgroundColor: '#F7F8FC',
    marginTop: '18px',
    marginBottom: '4px',
    border: '1px solid #F7F8FC',
    borderRadius: '4px',
    position: 'relative'
  },
  progressStopEvaluation: {
    position: "absolute",
    top: '14px',
    right: '14px'
  },
  progressLine: {
    flex: 1,
    height: "2px",
    backgroundColor: theme.palette.grey.grey200,
    marginTop: "-26px",
    marginLeft: "-35px",
    marginRight: "-35px",
    zIndex: 0,
    "&.line-done": {
      backgroundColor: theme.palette.primary.primary600
    }
  },
  progressBullets: {
    display: 'flex',
    width: '80%',
    maxWidth: '600px',
    justifyContent: 'space-between',
    placeItems: "center",
    zIndex: 5,
  },
  bulletRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 5
  },
  bullet: {
    width: '34px',
    height: '34px',
    display: "flex",
    textAlign: 'center',
    alignContent: 'center',
    alignItems: "center",
    justifyContent: "center",
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '130%',
    backgroundColor: '#F7F8FC',
    color: theme.palette.grey.grey500,
    borderRadius: '10px',
    border: '4px solid #FFF',
    boxShadow: '0px 2px 14px rgba(57, 73, 171, 0.32)',
    '&.bullet-active': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.primary200,
    },
    '&.bullet-done': {
      color: '#FFF',
      backgroundColor: theme.palette.primary.primary600,
    },
  },
  bulletLabel: {
    marginTop: '8px',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '120%',
    letterSpacing: '-0.16px',
    color: theme.palette.grey.grey500,
    '&.label-active': {
      color: theme.palette.grey.grey700,
    },
  },
  progressMessage: {
    alignSelf: 'flex-start',
    marginLeft: '16px',
    marginTop: '24px',
  },
  newEvaluationMessage: {
    alignSelf: 'flex-start',
    marginLeft: '16px',
    marginTop: '24px',
  },
  scoresWrapper: {
    display: 'flex',
    flexDirection: 'row',
    minHeight: '235px',
    backgroundColor: '#F7F8FC',
    marginBottom: '4px',
    position: 'relative'
    // gap: "16px",
  },
  globalScoreWrapper: {
    background:
      'radial-gradient(501.19% 107.24% at 7.02% 17.37%, rgba(199, 236, 0, 0.05) 0%, rgba(255, 255, 255, 0.10) 100%), #FFF',
    borderRadius: '15px',
    flexGrow: 1,
    margin: '16px 14px',
    padding: '14px 18px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  globalScoreTitle: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    alignSelf: 'flex-start',
    marginBottom: '8px',
    color: theme.palette.black.dark,
    '& img': {
      verticalAlign: 'bottom',
    },
  },
  globalScoreChart: {
    height: '110px',
    alignSelf: 'center',
  },
  globalScore: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    textAlign: 'center',
    color: theme.palette.black.dark,
    position: 'relative',
    bottom: '44px',
    '& .score': {
      fontSize: '34px',
    },
    '& .max-score': {
      opacity: 0.4,
    },
  },
  globalScoreDivider: {
    height: '1px',
    backgroundColor: theme.palette.grey.grey200,
    width: '90%',
    marginBottom: '12px',
  },
  globalScoreLabel: {},
  globalScorePerformance: {
    display: 'flex',
    justifyContent: 'center',
    borderRadius: '5px',
    fontFamily: 'Inter',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    width: 'fit-content',
    padding: '4px 12px',
    '&.outstanding': {
      color: '#426234',
      backgroundColor: 'rgba(67, 99, 40, 0.10)',
    },
    '&.advanced': {
      color: '#57BF53',
      backgroundColor: 'rgba(97, 196, 36, 0.10)',
    },
    '&.good': {
      color: '#CFE95C',
      backgroundColor: 'rgba(199, 236, 0, 0.10)',
    },
    '&.partial': {
      color: '#F6C655',
      backgroundColor: 'rgba(231, 198, 40, 0.10)',
    },
    '&.insufficient': {
      color: '#D75E47',
      backgroundColor: 'rgba(199, 82, 68, 0.10)',
    },
    '&.simple': {
      backgroundColor: "transparent",
      fontSize: '12px',
      fontWeight: 600,
      // fontFamily: 'Roboto', FontFamily not working because of merge conflicts ?
      padding: 0
    }
  },
  scoresDataWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 3,
    margin: '16px 14px 16px 0',
    gap: '16px',
  },
  scoresButtonsWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
    '& button span :first-of-type': {
      marginRight: '4px',
    },
  },
  datesWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '14px',
    flexGrow: 2,
  },
  badgeWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '9px',
  },
  badgeDetail: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '6px 12px',
    gap: '5px',
    flexShrink: 0,
    borderRadius: '10px',
    backgroundColor: '#F1EFEC',
    color: '#494A49',
    fontFamily: 'Inter',
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '130%',
  },
  badgeDetailLabel: {
    fontSize: '12px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    '& img': {
      verticalAlign: 'bottom',
    },
  },
  scoresAndDatesWrapper: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    position: 'relative',
  },
  scoresDetailTitleWrapper: {
    boxShadow:
      '0px 12.522px 38.692px 0px rgba(210, 208, 225, 0.12), 0px 6.65px 20.549px 0px rgba(210, 208, 225, 0.10), 0px 2.767px 8.551px 0px rgba(210, 208, 225, 0.07)',
    padding: '8px 14px',
    backgroundColor: '#F2F8FC',
    borderRadius: '12px',
    flexGrow: 5,
  },
  scoresDetailTitle: {
    color: theme.palette.grey.grey400,
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '16px',
    marginBottom: '12px',
  },
  scoresDetailWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  scoreDetail: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 6px',
    gap: '8px',
  },
  scoreInfoIcon: {
    '& img': {
      verticalAlign: 'text-top',
    },
  },
  scoreLabel: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '130%',
    textAlign: 'center',
    marginRight: 'auto',
    color: theme.palette.black.dark,
  },
  scoreValue: {
    fontFamily: 'Inter',
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '0.025px',
    color: '#FFF',
    textAlign: 'center',
    borderRadius: '16px',
    padding: '2px 6px 0 6px',
    '& span': {
      fontSize: '14px',
      fontWeight: 700,
      letterSpacing: '0.035px',
    },
    '&.outstanding': {
      backgroundColor: '#426234',
    },
    '&.advanced': {
      backgroundColor: '#57BF53',
    },
    '&.good': {
      backgroundColor: '#CFE95C',
    },
    '&.partial': {
      backgroundColor: '#F6C655',
    },
    '&.insufficient': {
      backgroundColor: '#D75E47',
    },
  },
  notableDates: {
    flexGrow: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '16px',
  },
  dateDetail: {
    display: 'flex',
    flexDirection: 'column',
  },
  dateLabel: {
    fontFamily: 'Inter',
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '110%',
    textTransform: 'uppercase',
    color: theme.palette.grey.grey300,
  },
  dateValue: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '110%',
    color: theme.palette.grey.main,
    '&.date-expired': {
      color: theme.palette.error.main,
    },
  },
  graphEvolutionDialog: {
    backgroundColor: theme.palette.grey.grey100,
    padding: '20px 40px',
  },
  graphEvolutionContent: {
    backgroundColor: theme.palette.grey.grey100,
    minWidth: '685px',
    minHeight: '348px',
    display: 'flex',
    justifyContent: 'center',
    padding: '20px 40px',
  },
  foundSupplierInfos: {
    backgroundColor: theme.palette.grey.grey100,
    borderRadius: '4px',
    padding: '30px 36px',
  },
  foundSupplierName: {
    color: theme.palette.primary.primary800,
    fontFamily: 'Inter',
    fontSize: '28px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '120%',
    letterSpacing: '-0.28px',
  },
  foundSupplierActivity: {
    color: theme.palette.primary.primary400,
    marginTop: '8px',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '130%',
  },
  foundSupplierBlocs: {
    display: 'flex',
    marginTop: '23px',
    gap: '126px',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '130%',
  },
  foundSupplierInfoBloc: {
    color: theme.palette.black.dark,
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '130%',
  },
  foundSupplierInfoBlocTitle: {
    color: theme.palette.black.dark,
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '120%',
    letterSpacing: '-0.16px',
    display: 'flex',
    gap: '2px',
    marginBottom: '8px',
  },
  foundSupplierInfoBlocValue: {
    color: theme.palette.grey.grey500,
  },
  historyBtnTooltipTitle: {
    display: 'flex',
  },
  scopeChangeButton: {
    position: 'absolute',
    right: '8px',
    bottom: '8px',
  },
  scopeChangeDetailWrapper: {
    color: theme.palette.black.dark,
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '130%',
  },
  scopeChangesBloc: {
    borderRadius: '0px 0px 8px 8px',
    background: 'rgba(242, 243, 247, 0.50)',
    marginTop: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '8px',
  },
  scopeChangeItem: {
    color: theme.palette.black.dark,
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '130%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  scopeChangeValue: {
    color: theme.palette.grey.grey600,
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '120%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '4px',
    '& img': {
      width: '16px',
    },
  },
  blurred: {
    filter: 'blur(10px)',
  },
  uniqueIdErrorWrapper: {
    zIndex: 100,
    width: '100%',
    height: '100%',
    minHeight: '235px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    placeContent: 'center',
    background: '#FCF9FB',
    backdropFilter: 'blur(75px)',
    borderRadius: '6px',
  },
  uniqueIdErrorAlertMsg: {
    fontWeight: 600,
  },
  integrationIdErrorInput: {
    marginRight: '22px',
    width: '350px',
    '& .MuiInputBase-root': {
      backgroundColor: '#FFF',
      borderRadius: '12px',
      border: 'none'
    },
  },
}));

export default useStyles;
